import { AppConfig, initConfig } from './app-config';

import { NgModule,Inject,APP_INITIALIZER} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatChipsModule} from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatTreeModule} from '@angular/material/tree';
import {MatTabsModule} from '@angular/material/tabs';
//  import {MatSort} from '@angular/material/sort';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {MatTooltipModule} from '@angular/material/tooltip';

import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';
import { LoginModule } from 'app/main/login/login.module';
import { RegisterModule } from 'app/main/register/register.module';
import { appRoutes } from './app.routes';

import { authInterceptorProviders } from 'app/main/auth/auth.interceptor';
import { JwtModule } from '@auth0/angular-jwt';
import { TokenStorageService } from './main/auth/token-storage.service';
import { UsuariosModule } from './main/apps/usuarios/usuarios.module';
import { ObjetivosModule } from './main/apps/objetivos/objetivos.module';
import {DimensionRiesgosModule} from './main/apps/dimensiones-riesgos/dimensiones-riesgos.module';
import {TipoEvaluacionRiesgosModule} from './main/apps/tipo-evaluacion/tipo-evaluacion.module';
import { FactorPonderacionModule} from './main/apps/factor-ponderacion/factor-ponderacion.module';
import {EstructuraJerarquicaModule} from './main/apps/estructura-jerarquica/estructura-jerarquica.module';
import {ReglaBaseModule} from './main/apps/regla-base/regla-base.module';
import {RiesgoModule} from './main/apps/riesgo/riesgo.module';
import {KriModule} from './main/apps/kri/kri.module';
import { ReportesModule } from './main/apps/reportes/reportes.module';
import { TablaDeEvaluacionModule } from './main/apps/tabla-de-evaluacion/tabla-de-evaluacion.module';
import { MarcoDeReferenciaModule } from './main/apps/marco-de-referencia/marco-de-referencia.module';
import { AnalisisDeBrechasModule } from './main/apps/analisis-de-brechas/analisis-de-brechas.module';
import { DebidaDiligenciaModule } from './main/apps/debida-diligencia/debida-diligencia.module';

import {ControlModule} from './main/apps/control/control.module';
import {EscenarioModule} from './main/apps/escenario/escenario.module';
import { EvaluacionModule } from './main/apps/evaluacion/evaluacion.module';
import { AuditoriasModule } from './main/apps/auditorias/auditorias.module';
import { CumplimientoModule } from './main/apps/cumplimiento/cumplimiento.module';


import { AuthGuardService } from './main/auth/auth-guard.service';
import { RoleGuardService } from './main/auth/role-guard.service';
import { TipoUsuarioModule } from './main/apps/tipo-usuario/tipo-usuario.module';
import { DashboardModule } from './main/apps/dashboard/dashboard.module';
import {PrintSectionModule} from './main/apps/print-section/print-section.module'
import { FormularioModule } from './main/apps/debida-diligencia/formulario/formulario.module';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// Registra los datos de localización para español.
registerLocaleData(localeEs);

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),
        JwtModule.forRoot({
            config: {
                tokenGetter: TokenStorageService.getToken2
            }
        }),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatSidenavModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatChipsModule,
        MatInputModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatTreeModule,
        MatTabsModule,
        //MatSort,
        NgxChartsModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,

        // App modules
        LayoutModule,
        SampleModule,
        LoginModule,
        RegisterModule,
        UsuariosModule,
        ObjetivosModule,
        DimensionRiesgosModule,
        TipoEvaluacionRiesgosModule,
        TipoUsuarioModule,
        FactorPonderacionModule,
        ReglaBaseModule,
        RiesgoModule,
        AuditoriasModule,
        DebidaDiligenciaModule,
        KriModule,
        ControlModule,
        EscenarioModule,
        EvaluacionModule,
        FormularioModule,
        ReportesModule,
        MatTooltipModule,
        CumplimientoModule,
        DashboardModule,
        TablaDeEvaluacionModule,
        MarcoDeReferenciaModule,
        AnalisisDeBrechasModule,
        PrintSectionModule
    ],
    providers   : [authInterceptorProviders,
                    AuthGuardService,
                    RoleGuardService,
                    AppConfig,
                    {
                      provide: APP_INITIALIZER,
                      useFactory: initConfig,
                      deps: [AppConfig],
                      multi: true
                    }],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
